import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import getCSRFToken from '../../utils/CSRFToken';

export default function InitialiseButton({ endpoints, useOnboardingStore }) {
  const { createUrl } = endpoints;

  const categories = useOnboardingStore((state) => state.categories);
  const pages = useOnboardingStore((state) => state.pages);
  const templates = useOnboardingStore((state) => state.templates);
  const isGenerateJobs = useOnboardingStore((state) => state.isGenerateJobs);
  const setIsLoading = useOnboardingStore((state) => state.setIsLoading);

  const createAllMutation = useMutation({
    mutationFn: async () => {
      const response = await fetch(`${createUrl}.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getCSRFToken(),
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          onboarding: {
            categories,
            dynamic_pages: pages,
            dynamic_page_templates: templates,
            is_generate_jobs: isGenerateJobs,
          },
        }),
      });

      if (!response.ok) {
        const errors = await response.json();
        const errorMessage = JSON.stringify(errors?.error) || 'An error occurred while creating or updating the dynamic brand';
        throw new Error(errorMessage);
      }
    },
    onMutate: () => {
      toast.loading('Loading...');
      setIsLoading(true);
    },
    onError: (error) => {
      toast.error(`Error: ${error.message || 'An error occurred while saving changes'}`);
    },
    onSuccess: () => window.location.reload(),
    onSettled: () => setIsLoading(false),
  });

  const isLoading = createAllMutation.isPending;

  return (
    <div className="d-flex">
      <button className="btn btn-primary" onClick={() => createAllMutation.mutate()} disabled={isLoading}>
        {isLoading ? 'Initialising...' : 'Initialise'}
      </button>
    </div>
  );
}
